import { useCallback } from 'react';
import { ConsentConfig } from '../../domain/Consent';
import { SessionData } from '../../domain/Session';
import { SessionAuthAPI } from './SessionAuthAPIInterface';
import { AuthRequest } from '../../domain/AuthRequest';

// Define your custom hook
export function useAuthAPI(api: SessionAuthAPI) {
    // Memoize the submitUsername function
    const submitUsername = useCallback(async (loginName: string, authRequestID: string): Promise<SessionData> => {
        return await api.submitUsername(loginName, authRequestID);
    }, [api]);

    // Memoize the submitPassword function
    const submitPassword = useCallback(async (password: string, sessionId: string): Promise<SessionData> => {
        return await api.submitPassword(password, sessionId);
    }, [api]);

    // Memoize the submitOTP function
    const submitOTP = useCallback(async (code: string, sessionId: string): Promise<SessionData> => {
        return await api.submitOTP(code, sessionId);
    }, [api]);

    // Memoize the submitOtpEmail function
    const submitOtpEmail = useCallback(async (code: string, sessionId: string): Promise<SessionData> => {
        return await api.submitOtpEmail(code, sessionId);
    }, [api]);

    // Memoize the submitOtpSMS function
    const submitOtpSMS = useCallback(async (code: string, sessionId: string): Promise<SessionData> => {
        return await api.submitOtpSMS(code, sessionId);
    }, [api]);

    const sendOtpEmail = useCallback(async (sessionId: string): Promise<SessionData> => {
        return await api.sendOtpEmail(sessionId);
    }, [api]);

    const sendOtpSms = useCallback(async (sessionId: string): Promise<SessionData> => {
        return await api.sendOtpSms(sessionId);
    }, [api]);

    // Memoize the getConsentConfig function
    const getConsentConfig = useCallback(async (): Promise<ConsentConfig> => {
        return await api.getConsentConfig();
    }, [api]);

    // Memoize the submitConsent function
    const submitConsent = useCallback(async (consentData: Map<string,string[]>): Promise<void> => {
        return await api.submitConsent(consentData);
    }, [api]);

    // Memoize the sendAuthRequest function
    const sendAuthRequest = useCallback(async (): Promise<AuthRequest> => {
        return await api.sendAuthRequest();
    }, [api]);

    return {
        submitUsername,
        submitPassword,
        submitOTP,
        submitOtpEmail,
        submitOtpSMS,
        sendOtpEmail,
        sendOtpSms,
        getConsentConfig,
        submitConsent,
        sendAuthRequest,
    };
}
